import { HttpService, Query, QueryHandler, TaggedUrl, Tags } from '@skylab-shared/core';
import { IntegrationType } from './integrations-list.query-base';

export enum IntegrationKind {
  Marketplace = 'Marketplace',
  ShipmentProviders = 'ShipmentProviders',
  DocumentProviders = 'DocumentProviders',
}

export enum AuthenticationType {
  Unspecified = 0,
  AuthenticationToken = 1,
  LoginAndPassword = 2
}

export type AvailableIntegrationProvider = {
  kind: IntegrationKind,
  providerType: string,
  providerEnvironment: string,
  providerDisplayName: string,
  authenticationType: AuthenticationType
};

type AvailableIntegrationsListResponse = {
    data: {
        items: AvailableIntegrationProvider[],
        metadata: {
            page: number,
            total: number
        }
    }
}

/**
* Query gets list of available integrations in Artemis. For now it's returns only Allegro and AllegroSandbox.
*/
export class AvailableIntegrationsListQuery extends Query<AvailableIntegrationProvider[]> { }

export class AvailableIntegrationsListQueryHandlerBase implements QueryHandler<AvailableIntegrationsListQuery, AvailableIntegrationProvider[]> {
  private static Url = TaggedUrl.join('Integrations/available', [Tags.SelloApi]);

  public constructor(
    private readonly http: HttpService
  ) { }

  public async handleAsync(_: AvailableIntegrationsListQuery): Promise<AvailableIntegrationProvider[]> {
    const response = await this.http.get<AvailableIntegrationsListResponse>(AvailableIntegrationsListQueryHandlerBase.Url);
    // FIXME: na razie wybór pomiędzy Allegro, a AllegroSandbox, jeśli są dostępne obydwa - filtrowanie do usunięcia jak będzie więcej integracji.
    return response.data.data.items
      .filter(i => i.kind === IntegrationKind.Marketplace)
      .filter(i => i.providerType === IntegrationType.Allegro || i.providerType === IntegrationType.AllegroSandbox);
  }
}